import React,{ Component } from "react";
import {connect} from 'react-redux';
import { getIdea,delIdea,updateIdea } from '../../actions';
import Loading from './Loading';

class GetIdea extends Component {
    constructor(props){
        super(props);
        this.state={idea:'',error:null,showEditBox:false,updatedIdea:'',isFetching:true};
    }
    componentWillMount(){
        this.props.getIdea(this.props.user.uid);
    }


    ideaList(){
        let {ideas,user} = this.props;
        let {showEditBox} = this.state;

        if(ideas.ideas){
            return(
                <div style={{paddingBottom:'60px',paddingTop:'20px'}}>
                 {showEditBox?this.editBox():
                     <ul className='list-group col'>
                        {ideas.ideas.map(idea=>{
                            return(
                            <li key={idea.id} className='list-group-item'>
                                <div className='list-item'>
                                <div>{idea.idea}</div>
                                </div>
                                <div className='list-item btn-box'>
                                <i className="fas fa-pencil-alt edit-btn"
                                   onClick={()=>this.setState({showEditBox:true,idea:idea})}></i>
                                <i className='fa fa-trash-alt delete-btn' onClick={()=>this.props.delIdea({user_id:user.uid,id:idea.id})}></i>
                                </div>
                            </li>
                            )
                        })}
                     </ul>
                    }
                </div>
            )
        }
    }

    updateIdea(){
        let {updatedIdea} = this.state;
        let {updateIdea,user} = this.props;
        if(updatedIdea!==''){
            updateIdea({user_id:user.uid,...updatedIdea});
            this.setState({showEditBox:false});
        }
    }

    editBox(){
        let {idea} = this.state;
        return(
                <div>
                    <div className="form-group"> 
                    <label htmlFor="inputIDEA">Update your idea</label>
                        <input 
                        type='text'
                        id='inputIDEA'
                        className="form-control" 
                        maxLength='200'
                        minLength='30'
                        defaultValue={idea.idea}
                        onChange={(e)=>this.setState({updatedIdea:{id:idea.id,idea:e.target.value}})}
                        ></input>
                    </div>
                    <div className='form-group'>
                        <button className='btn btn-outline-success' onClick={()=>this.updateIdea()}>Submit</button>
                        <button className='btn btn-outline-secondary' style={{marginLeft:'5px'}} onClick={()=>this.setState({showEditBox:false})}>Cancel</button>
                    </div>
                </div>
        )
    }
    render(){
        // console.log(this.props.user);
        //console.log(this.props);
        let res = this.props.ideas.result;
        return(
            <div>
                {
                    res==='success' ? 
                    this.ideaList() : 
                    res==='error' ? 
                    <div style={{color:'red'}}><h3>Oops, something went wrong. Check your internet and try again.... :/</h3></div> :
                    res==='empty' ? <div> You haven't submitted any idea. :( </div> :
                    <Loading />

                }
            </div>
        )
    }
}

function mapStateToProps(state){
    return {ideas:state.idea}
}

export default connect(mapStateToProps,{getIdea,delIdea,updateIdea})(GetIdea);




// WEBPACK FOOTER //
// ./src/components/goals/GetIdea.jsx